import React from 'react';

let active = 0; const subs: (()=>void)[] = [];

export default function TopLoader(){
  const [count,setCount] = React.useState(active);
  React.useEffect(()=>{ const fn=()=>setCount(active); subs.push(fn); return ()=>{ const i=subs.indexOf(fn); if(i>-1) subs.splice(i,1); }; },[]);
  return <div className="top-loader" data-active={count>0} />;
}
